(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-chart-modal"] && !Shopify.designMode) return;
  try {
    class SizeChartModal {
    constructor() {
      this.modal = document.querySelector('[data-size-chart-modal]');
      this.trigger = document.querySelector('[data-size-chart-trigger]');
      this.closeButtons = document.querySelectorAll('[data-size-chart-close]');

      if (!this.modal || !this.trigger) return;

      document.body.appendChild(this.modal);
      this.init();
    }

    init() {
      this.trigger.addEventListener('click', () => this.open());
      this.closeButtons.forEach(btn => btn.addEventListener('click', () => this.close()));
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal || e.target.closest('[data-size-chart-close]')) {
          this.close();
        }
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) this.close();
      });
    }

    open() {
      this.modal.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
      const closeBtn = this.modal.querySelector('[data-size-chart-close]');
      if (closeBtn) closeBtn.focus();
    }

    close() {
      this.modal.removeAttribute('data-open');
      document.body.style.overflow = '';
      if (this.trigger) this.trigger.focus();
    }

    isOpen() {
      return this.modal.hasAttribute('data-open');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new SizeChartModal());
  } else {
    new SizeChartModal();
  }
  } catch(e) { console.error(e); }
})();

})();
